import ITexts from "./ITexts";

const en: ITexts = {
  donation_project_list_header: "Donate",
  donation_project_list_item_go_to_project: "Zum Projekt",
  donation_1_donate_now_1: "Donate from ",
  donation_1_donate_now_2: " now",
  donation_abort_button: "cancel",
  donation_info: "Hinweis",
  donation_alert: "Any alert message",
  donation_now_disabled: "Register and donate",
  donation_continue: "Continue",
  donation_progress_bar_by: "by",
  donation_progress_bar_donator: "Investor",
  donation_progress_bar_donators: "Investors",
  donation_side_bar_requiredBudget: "Donation goal",
  donation_side_bar_region: "Region",
  donation_side_bar_mainFocus: "Main focus",
  donation_side_bar_matchFunding: "Matchfunding",
  donation_close_button: "Close"
};

export default en;
